<template>
  <div>
    <highcharts v-if="!isEmptyData" :options="options" ref="highchart" />
    <div v-else class="empty_box">
      <span class="empty_text">데이터가 없습니다.</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, cloneDeep, isEqual } from 'lodash';
import { columnOptions } from '@/constants/chart-options';
import amsSummaryApi from '@/api/ams/summary';

export default {
  name: 'WTriggerJobColumnChart',
  props: {
    tabActive: {
      type: Boolean,
      default: false,
    },
    /**
     * 컬럼 차트 데이터 종류 (수행 템플릿, 실패 템플릿, 실패 작업 topN)
     * @type {Object}
     */
    type: {
      type: String,
    },
  },
  data() {
    return {
      options: cloneDeep(columnOptions),
      isEmptyData: true,
    };
  },
  computed: {
    ...mapGetters(['analysisDateParams']),
  },
  watch: {
    analysisDateParams() {
      this.loadData();
    },
    tabActive: {
      handler(flag) {
        if (flag) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.setChartOption();
  },
  methods: {
    loadData() {
      if (!this.tabActive) return;
      amsSummaryApi.getExecResultTopNData({
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
        type: this.type,
      }).then((response) => {
        const result = response.data;
        if (result.success) {
          this.setChartData(cloneDeep(result.data));
        }
      });
    },
    /**
     * 차트 옵션 설정
     * @author jeee12
     */
    setChartOption() {
      const me = this;
      this.options.chart.height = '250px';
      this.options.legend = false;
      this.options.yAxis.allowDecimals = false;
      this.options.plotOptions = {
        series: {
          className: 'c-pointer',
          point: {
            events: {
              click() {
                const trigger = {
                  name: this.options.name,
                  tagType: 'success',
                  type: 'triggerList',
                  selected: true,
                  triggerId: this.options.data.triggerId,
                };
                const status = {
                  tagType: 'info',
                  type: 'resultStatus',
                  selected: true,
                  label: '실패',
                  name: '실패',
                };
                if (isEqual(me.type, 'failJob')) {
                  me.$emit('change-active-tab', 'result', 'JOB', [status]);
                } else if (isEqual(me.type, 'failTrg')) {
                  me.$emit('change-active-tab', 'result', 'TRIGGER', [trigger, status]);
                } else {
                  me.$emit('change-active-tab', 'result', 'TRIGGER', [trigger]);
                }
              },
            },
          },
        },
      };
    },
    /**
     * 컬럼 차트 데이터 바인딩
     * @author jeee12
     * @param  {[type]} data [description]
     */
    setChartData(data) {
      this.isEmptyData = isEmpty(data);
      const colorSet = this.options.colors;
      const categories = [];
      const series = data.reduce((acc, val, index) => {
        acc.push({ borderColor: colorSet[index], color: colorSet[index], ...val });
        categories.push(val.name);
        return acc;
      }, []);

      this.options.xAxis.categories = categories;
      this.options.series = [
        {
          name: `${this.type === 'execTrg' ? '수행' : '실패'} 횟수`,
          data: series,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.empty_box {
  width: 100%;
  min-height: 180px;
  display: table;
  .empty_text {
    display: table-cell;
    vertical-align: middle;
    // text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionSummary/components/TriggerJobColumnChart.vue